import { addStockInUserWatchList, updateStockInUserWatchList, deleteStockFromWatchList } from '../../services/UserStockWatchingDefinitionService'
import { createNewList, getAllListWithEntries, updateListInfo, deleteList } from '../../services/UserStockListService'
import { getListNameFromType } from '../helpers/ListHelper'

const initialState = () => {
    return {
        loaded: {
            buyLists: false,
            sellLists: false
        },
        stockOptionWatchList: [],
        lists: {
            buyLists: [],
            sellLists: []
        },
        bestLists: {
            buys: [],
            sells: []
        },
        focusedLists: []
    };
};
var listDataStore = {
    state: Object.assign({}, initialState()),
    mutations: {
        setUserLists(state, { listType, lists }) {
            state.lists[listType] = lists;
            state.loaded[listType] = true;
        },

        stockOptionWatchList(state, { stockOptionWatchList }) {
            state.stockOptionWatchList = stockOptionWatchList
        },

        addList(state, { listName, listInfos }) {
            state.lists[listName].push(listInfos);
        },

        updatedList(state, { listInfos, listName }) {
            const listToUpdate = state.lists[listName].find(list => list.id === listInfos.id)
            listToUpdate.name = listInfos.name
            listToUpdate.description = listInfos.description
            if (listInfos.currency) {
                listToUpdate.currency = listInfos.currency
            }
        },

        deleteList(state, { listId, listName }) {
            state.lists[listName] = state.lists[listName].filter(list => list.id !== listId);
        },

        addStockInList(state, { listId, item, listName }) {
            state.lists[listName].find(list => list.id === listId).entries.push(item);
        },

        updateStockInList(state, { listId, item, listName }) {
            let entries = state.lists[listName].find(list => list.id === listId).entries;
            const updatedEntries = entries.map(entry => entry.id === item.id ? Object.assign(entry, item) : entry);
            entries = updatedEntries;
        },

        deleteStockInList(state, { listId, entryId, listName }) {
            const list = state.lists[listName].find(list => list.id === listId);
            list.entries = list.entries.filter(entry => entry.id !== entryId);
        },

        focusOnList(state, { listIds }) {
            state.focusedLists = listIds;
        },

        unfocusOnList(state) {
            state.focusedLists = [];
        },

        reset(state) {
            Object.assign(state, initialState());
        }
    },

    actions: {
        setUserBuyLists(context, { buyLists }) {
            context.commit('setUserLists', { listType: 'buyLists', lists: buyLists });
        },

        getAllSellListWithEntries(context) {
            return new Promise((resolve, reject) => {
                getAllListWithEntries({ userId: this.state.user.authenticatedUser.userId, listType: 'sell' }).then((response) => {
                    context.commit('setUserLists', { listType: 'sellLists', lists: response.lists });
                    resolve();
                }).catch((error) => { reject(error) });
            });
        },

        addStockInWatchList(context, { listId, item, listType }) {
            return new Promise((resolve, reject) => {
                addStockInUserWatchList({ listId: listId, newEntry: item, listType }).then((response) => {
                    const listName = getListNameFromType({ listType });
                    context.commit('addStockInList', { listId, item: response.addedUserListEntry, listName: listName });
                    this.dispatch('setUsage', { usage: response.usage }, { root: true });
                    resolve(response.addedUserListEntry);
                }).catch(error => { reject(error) })
            });
        },

        updateStockInUserWatchList(context, { listId, item, listType }) {
            return new Promise((resolve, reject) => {
                updateStockInUserWatchList({ listId, updatedListEntry: item.rawData, listType }).then((updatedUserListEntry) => {
                    const listName = getListNameFromType({ listType });
                    context.commit('updateStockInList', { listId, item: updatedUserListEntry, listName: listName });
                    resolve();
                }).catch(error => { reject(error) })
            });
        },

        deleteStockFromWatchList(context, { listId, entryId, listType }) {
            return new Promise((resolve, reject) => {
                deleteStockFromWatchList({ entryId, listId, listType }).then((response) => {
                    const listName = getListNameFromType({ listType });
                    context.commit('deleteStockInList', { listId, entryId, listName: listName });
                    this.dispatch('setUsage', { usage: response.usage }, { root: true });
                    resolve();
                }).catch(error => { reject(error) })
            });
        },

        createNewList(context, { userId, listName, listDescription, listType }) {
            return new Promise((resolve, reject) => {
                createNewList({ userId, listName, listDescription, listType }).then((response) => {
                    const listName = getListNameFromType({ listType });
                    context.commit('addList', { listName: listName, listInfos: response.list });
                    this.dispatch('setUsage', { usage: response.usage }, { root: true });
                    resolve();
                }).catch(error => { reject(error) })
            });
        },

        updateListInfos(context, { listId, listName, listDescription, listType }) {
            return new Promise((resolve, reject) => {
                updateListInfo({ listId, listName, listDescription, listType }).then((response) => {
                    const listName = getListNameFromType({ listType });
                    context.commit('updatedList', { listInfos: response, listName: listName });
                    resolve()
                }).catch(error => { reject(error) })
            });
        },

        deleteList(context, { listId, listType }) {
            return new Promise((resolve, reject) => {
                deleteList({ listId, listType }).then((response) => {
                    const listName = getListNameFromType({ listType });
                    context.commit('deleteList', { listId, listName: listName });
                    this.dispatch('setUsage', { usage: response.usage }, { root: true });
                    resolve();
                }).catch(error => { reject(error) })
            });
        },

        hoverScoredStockCard(context, { stock }) {
            context.commit('focusOnList', { listIds: stock.getScoreInfos().map(e => e.list.id) });
        },

        leaveScoredStockCard(context) {
            context.commit('unfocusOnList');
        },

        resetLists(context) {
            context.commit('reset');
        }
    },

    getters: {
        buyListsLoaded(state) {
            return state.loaded.buyLists;
        },
        sellListsLoaded(state) {
            return state.loaded.sellLists;
        },
        allListAreLoaded(state) {
            return state.loaded.sellLists & state.loaded.buyLists
        },
        userLists(state) {
            return state.lists;
        },
        bestLists(state) {
            return state.bestLists
        },
        getListFromId: (state) => (listId) => {
            for (const listKey in state.lists) {
                for (const obj of state.lists[listKey]) {
                    if (obj.id === listId) {
                        return obj;
                    }
                }
            }
            return null;
        },
        stockIsInList: (state, getters) => (listId, stockId) => {
            const list = getters.getListFromId(listId);
            if (list) {
                return list.entries.some(e => e.stockId === stockId);
            }
            return false;
        }
    }
}

export default listDataStore;
